import { useEffect } from "react";

const INLINE_ID = "sa-dynamic-optimization";
const UUID = "799b2c53-ec3a-4ec5-a4db-4001304cbaf7";
const INLINE_SRC =
  "data:text/javascript;base64,dmFyIHNjcmlwdCA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoInNjcmlwdCIpO3NjcmlwdC5zZXRBdHRyaWJ1dGUoIm5vd3Byb2NrZXQiLCAiIik7c2NyaXB0LnNldEF0dHJpYnV0ZSgibml0cm8tZXhjbHVkZSIsICIiKTtzY3JpcHQuc3JjID0gImh0dHBzOi8vZGFzaGJvYXJkLnNlYXJjaGF0bGFzLmNvbS9zY3JpcHRzL2R5bmFtaWNfb3B0aW1pemF0aW9uLmpzIjtzY3JpcHQuZGF0YXNldC51dWlkID0gIjc5OWIyYzUzLWVjM2EtNGVjNS1hNGRiLTQwMDEzMDRjYmFmNyI7c2NyaXB0LmlkID0gInNhLWR5bmFtaWMtb3B0aW1pemF0aW9uLWxvYWRlciI7ZG9jdW1lbnQuaGVhZC5hcHBlbmRDaGlsZChzY3JpcHQpOw==";

export const SearchAtlasLoader = () => {
  useEffect(() => {
    if (document.getElementById(INLINE_ID)) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.setAttribute("nowprocket", "");
    script.setAttribute("nitro-exclude", "");
    script.id = INLINE_ID;
    script.dataset.uuid = UUID;
    script.src = INLINE_SRC;
    document.head.appendChild(script);
  }, []);

  return null;
};

export default SearchAtlasLoader;